import {useEffect, useRef} from 'react';

/**
 * useFirstRender is a custom hook that determines if the current render
 * is the first render of a React component.
 *
 * It uses a `useRef` to persist a boolean value across renders, starting
 * as `true` for the initial render. After the first render, it updates the
 * value to `false` using a `useEffect`.
 *
 * @function
 * @returns {boolean} - Returns `true` if it is the first render, otherwise `false`.
 */
const useFirstRender = () => {
    const firstRender = useRef(true);

    useEffect(() => {
        firstRender.current = false;
    }, []);

    return firstRender.current;
}

export default useFirstRender